<template>
  <v-card :style="{ 'min-height': `${height}px`}" :class="['d-flex', 'flex-grow-1', { 'primary': dark}, {'darken-4' : dark}]" :dark="dark">

    <!-- loading spinner -->
    <div v-if="loading" class="d-flex flex-grow-1 align-center justify-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <!-- information -->
    <div v-else class="d-flex flex-column flex-grow-1">
      <v-card-title>
        <div>{{ label }}</div>
        <v-spacer></v-spacer>
        <v-btn v-if="actionLabel" text color="primary" @click="$emit('action-clicked')">{{ actionLabel }}</v-btn>
      </v-card-title>      
      
      <div class="d-flex flex-column flex-grow-1">
        <div class="pa-2">
          <div class="text-h4">
            {{ value.toFixed(2) }} %
          </div>
          <div class="primary--text text--lighten-1 mt-1">
            {{ valueCount }} {{ countSuffix }}
          </div>
        </div>
        <!--
        <v-spacer></v-spacer>
        -->
        <div class="px-2 pb-2" v-if="percentageLabel">
          
          <div class="d-flex align-center justify-end">
            <div class="d-flex flex-column text-right">
              <div class="font-weight-bold">
                <trend-percent :value="percentage" />
              </div>
              <div class="caption">{{ percentageLabel }}</div>
            </div>
          </div>
        </div>
      </div>
      <apexchart
        type="area"
        :height="chartHeight"
        :options="chartOptions"
        :series="series"
      ></apexchart>
    </div>
  </v-card>
</template>

<script>
import TrendPercent from './TrendPercent'
import Formatters from '@/mixins/formatters'

/*
|---------------------------------------------------------------------
| DEMO Dashboard Card Component
|---------------------------------------------------------------------
|
| Demo card component to be used to gather some ideas on how to build
| your own dashboard component
|
*/
export default {
  components: {
    TrendPercent
  },
  mixins: [Formatters],
  props: {
    value: {
      type: Number,
      default: 0
    },
    valueCount: {
      type: Number,
      default: 0
    },
    countSuffix: {
      type: String,
      default: 'orders'
    },
    percentage: {
      type: Number,
      default: 0
    },
    percentageLabel: {
      type: String
    },
    series: {
      type: Array
    },
    xaxis: {
      type: Object
    },
    label: {
      type: String,
      default: 'Rate'
    },
    actionLabel: {
      type: String
    },
    options: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    dark: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 200
    },
    chartHeight: {
      type: Number,
      default: 120
    }
  },
  computed: {
    chartOptions() {
      //let t = this;
      const primaryColor = this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark.primary
        : this.$vuetify.theme.themes.light.primary
      const secondaryColor = this.$vuetify.theme.isDark
        ? this.$vuetify.theme.themes.dark.success
        : this.$vuetify.theme.themes.light.success
      return {
        chart: {
          height: this.chartHeight,
          type: 'area',
          sparkline: {
            enabled: true
          },
          animations: {
            speed: 400
          }
        },
        colors: [primaryColor, secondaryColor],
        fill: {
          type: 'solid',
          colors: [primaryColor, secondaryColor],
          opacity: 0.15
        },
        stroke: {
          curve: 'smooth',
          width: 2
        },
        xaxis: this.xaxis,
        yaxis: this.series.map(s => {return { title: { text: s.title }, show: false }}),
        tooltip: {
          followCursor: true,
          //theme: 'dark',
          theme: this.dark ? 'dark' : 'light',
          style: {
            fontFamily: 'Quicksand, sans-serif'
          },
          x: {
            format: 'd.M.yyyy',
          },
          y: {
            formatter: function(value, { /*series,*/ seriesIndex, /*dataPointIndex, w */}) {
              return seriesIndex == 0 ? `${value.toFixed(2)} %` : value.toFixed(0)
            }
          },
          /*
          custom: function({ ctx, series, seriesIndex, dataPointIndex, w }) {
            const seriesName = w.config.series[seriesIndex].name

            return `<div class="rounded-lg pa-1 caption">
              <div class="font-weight-bold">${t.formatDate(w.globals.labels[dataPointIndex])}</div>
              <div> ${seriesName} ${series[seriesIndex][dataPointIndex].toFixed(seriesIndex == 0 ? 2: 0)}${seriesIndex == 0 ? '%' : ''}</div>
            </div>`
          }
          */
        },
        ...this.options
      }
    }
  },
  methods: {
  }
}
</script>
